module.exports = __webpack_public_path__ + "static/media/cartoes_cvv.e2b6b21e.svg";